module.exports = __webpack_public_path__ + "img/Black_Pheasant.f57f190f.svg";